<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-full sm:w-full h-full">
      <BaseFetchData :action="fetchContact">
        <template #default="fetchDataProps">
          <div v-if="fetchDataProps.status.loading">
            <Loader />
          </div>
          <div v-else-if="fetchDataProps.status.resolved" class="flex h-full">
            <Sidebar :contact-id="contactId" />
            <div class="bg-gray-50 flex-1 rounded-r-lg px-4 py-5 sm:px-6 flex flex-col">
              <div class="flex flex-none justify-end mb-6">
                <button
                  type="button"
                  class="rounded-md text-gray-400 hover:text-gray-800 focus:outline-none"
                  @click="close"
                >
                  <!-- Heroicon name: outline/x -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
              <div class="flex-1 px-4 overflow-y-auto">
                <MainSection :contact-id="contactId" />
              </div>
            </div>
          </div>
          <div v-else class="h-full flex items-center justify-center">
            <div class="space-y-4 text-center">
              <p class="mx-auto">
                {{ fetchDataProps.rejectReason }}
              </p>
              <BaseButton primary @click="close"> Close </BaseButton>
            </div>
          </div>
        </template>
      </BaseFetchData>
    </div>
  </VModal>
</template>

<script>
import Sidebar from './Sidebar.vue';
import MainSection from './MainSection.vue';

export default {
  name: 'ContactModal',
  components: {
    Sidebar,
    MainSection,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  provide() {
    return {
      fetchContact: this.fetchContact,
      updateContact: this.updateContact,
      deleteContact: this.deleteContact,
      closeModal: this.close,
    };
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    '$route.name': {
      handler(name, prevName) {
        if (name !== prevName) {
          this.close();
        }
      },
    },
  },
  methods: {
    async fetchContact() {
      try {
        await this.$store.dispatch('ui/contacts/read', {
          id: this.contactId,
          query: {
            include: [
              'primaryEmailAddress',
              'emailAddresses',
              'phoneNumbers',
              'user',
              'contactRequestsCount',
              'accOrdersCount',
              'notesCount',
              'purchasedAccProductsCount',
              'accProductReactionsCount',
              'accountsCount',
              'emailMessagesCount',
              'smsMessagesCount',
              'contactsWithCommonEmailAddressCount',
              'contactsWithCommonPhoneNumberCount',
            ],
          },
        });

        return 1;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async updateContact(formData) {
      await this.$store.dispatch('ui/contacts/update', {
        id: this.contactId,
        formData,
      });

      this.$emit('contact-updated');

      return true;
    },
    async deleteContact() {
      try {
        await this.$store.dispatch('ui/contacts/destroy', {
          contactId: this.contactId,
        });

        this.$emit('contact-deleted', this.contact);

        this.close();
      } catch (error) {
        //
      }

      return true;
    },
    close() {
      this.$refs.modal.close();
    },
  },
};
</script>
